"use client";

import { useEffect, useState } from "react";
import { useSearchParams } from "next/navigation";
import { useAuthContext } from "@/context/AuthContext";
import {
  isParentAudienceSearchParams,
  PARENT_AUDIENCE_SESSION_KEY
} from "@/lib/tiktokInviteRedirect";

/**
 * Returns true if the visitor is a parent — either logged in as one,
 * or arriving via a parent campaign with ?audience=ouder or ?recipient=ouder.
 *
 * The URL parameter is persisted in sessionStorage so it survives
 * navigation within the same tab/session.
 */
export function useParentAudience(): boolean {
  const { isParent } = useAuthContext();
  const searchParams = useSearchParams();
  const isUrlParentAudience = isParentAudienceSearchParams(searchParams);
  const [isParentAudience, setIsParentAudience] = useState(isUrlParentAudience);

  useEffect(() => {
    if (isUrlParentAudience) {
      sessionStorage.setItem(PARENT_AUDIENCE_SESSION_KEY, "true");
      setIsParentAudience(true);
    } else if (
      sessionStorage.getItem(PARENT_AUDIENCE_SESSION_KEY) === "true"
    ) {
      setIsParentAudience(true);
    }
  }, [isUrlParentAudience]);

  return isParent || isUrlParentAudience || isParentAudience;
}
